import Cookies from './cookies'

let DefaultLang = "en";
let AvailableLangs = ["it", "en"];

export default class Lang {

    static Get () {
        let userLang = Cookies.Get("Lang") || navigator.language || navigator.userLanguage;
        userLang = userLang.split("-")[0].toLowerCase();
        if (AvailableLangs.indexOf(userLang) < 0)
            userLang = DefaultLang;
		return userLang;
    }

}